export enum PopupAction {
  Delete = "delete",
  Cancel = "cancel",
  CreatePeering = "CreatePeering"
}
